// Connect copy of the parts of sidekick-web's MeetingView that the call page
// shares. Connect has no meetings, so MeetingView itself is left out.
import { colors } from "../../style";
import { ui } from "../ui";

export const DETAIL_TABS = [
  { value: "summary", label: "Summary" },
  { value: "transcript", label: "Transcript" },
  { value: "ask", label: "Ask Sidekick" },
];

// Chip, title and a muted meta line, with actions on the right
export function DetailHeader({ chip, title, meta, actions }) {
  return (
    <div
      style={{
        display: "flex",
        gap: "12px",
        alignItems: "flex-start",
        flexWrap: "wrap",
      }}
    >
      <div style={{ flex: "1 1 280px", minWidth: 0 }}>
        {chip}
        {title}
        {meta && (
          <p style={{ ...ui.muted, margin: "4px 0 0", fontSize: "13px" }}>
            {meta}
          </p>
        )}
      </div>
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
        {actions}
      </div>
    </div>
  );
}

export const detailTitle = (size) => ({
  margin: "8px 0 0",
  fontSize: `${size}px`,
  lineHeight: 1.25,
  color: colors.text,
  fontWeight: 700,
});
